import { assocPath, pathOr } from 'ramda'

export const solveNewValue = <T>(prevArray: T[], value: T) => {
  let changed = false
  let newArray = prevArray.filter((item) => {
    if (item === value) {
      changed = true
      return false
    }
    return true
  })

  if (!changed) {
    newArray = [...prevArray, value].filter((item) => {
      if (typeof item === 'string') {
        return item.trim() !== ''
      }
      if (typeof item === 'number') {
        return !isNaN(item)
      }
      return false
    })
  }

  return newArray
}

export const mergeValuesInArray = (state: object, path: string, value: object | string | boolean | number) => {
  const statePath = path.split('.')
  const prevArray = pathOr([], statePath, state)
  if (prevArray.length === 0) {
    return assocPath(statePath, [value], state)
  }
  const newArray = solveNewValue(prevArray, value)

  return assocPath(statePath, newArray, state)
}

export default { mergeValuesInArray }
